$('.staff-wrapper').click(function() {
	
	const staffWrapper = $(this);
	const staffId = $(this).data('id');
	const staffDetailsContainer = $(`[data-staff-id='${staffId}']`);

	if( ! staffDetailsContainer.hasClass('active') ) {

		$('.staff-details').slideUp('slow').removeClass('active');
		staffDetailsContainer.addClass('active').slideDown('slow');

		if ( window.matchMedia("(min-width: 1200px)").matches ) { 

			const trianglePos = staffWrapper.offset().left + 15;
			$('#triangle').css('left', trianglePos).show();
		}

		$('html,body').animate({
			scrollTop: $('#staffMemberDetails').offset().top - 55
		}, 500);

	} else {
		$('.staff-details').removeClass('active');
		staffDetailsContainer.slideUp('slow');
			$('#triangle').hide();
	}
});

// function insertAfterQueryRow() {
// 	if ( this.matchMedia("(min-width: 1200px)").matches ) { 

// 	} else if ( this.matchMedia("(min-width: 992px)").matches ) {

// 	} else if ( this.matchMedia("(min-width: 768px)").matches ) {

// 	} else {

// 	}
// }